import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * Compact "Über uns" teaser between TrackRecord and Conditions.
 * Single-row layout — 2 photos + 2 short sentences + "Mehr über uns" CTA.
 */
export const AboutTeaser = () => (
  <section
    id="about-teaser"
    data-testid="about-teaser"
    className="max-w-6xl mx-auto px-5 sm:px-8 py-16 sm:py-20"
  >
    <div className="al-card p-6 sm:p-9 bg-gradient-to-br from-[var(--al-grad-soft)] via-white to-violet-50/30">
      <div className="grid lg:grid-cols-[auto_1fr_auto] items-center gap-6 sm:gap-9">
        {/* Photos — overlapping pair */}
        <div className="flex -space-x-4" data-testid="about-teaser-photos">
          <img
            src="/team-adrian.jpg"
            alt="Adrian Bienz"
            className="h-20 w-20 sm:h-24 sm:w-24 rounded-full object-cover ring-4 ring-white shadow-lg shadow-violet-900/10"
          />
          <img
            src="/team-pascal.jpg"
            alt="Pascal Schwab"
            className="h-20 w-20 sm:h-24 sm:w-24 rounded-full object-cover ring-4 ring-white shadow-lg shadow-violet-900/10"
          />
        </div>

        {/* Copy */}
        <div className="min-w-0">
          <span className="al-tag">Über uns</span>
          <h3 className="mt-3 font-display font-bold text-2xl sm:text-3xl tracking-tight">
            Zwei Köpfe hinter <span className="al-grad-text">Alphalane.</span>
          </h3>
          <p className="mt-3 text-sm sm:text-base text-slate-700 leading-relaxed max-w-xl">
            <strong className="text-slate-900">Adrian Bienz</strong> &amp;{" "}
            <strong className="text-slate-900">Pascal Schwab</strong> — Trader,
            Robot-Programmierer und Geschäftsführer. Wir verbinden 10+ Jahre
            Börsenexpertise mit moderner KI-Programmierung, damit dein Geld
            arbeitet, ohne dass du selbst zum Trader werden musst.
          </p>
        </div>

        {/* CTA */}
        <Link
          to="/about"
          data-testid="about-teaser-cta"
          className="al-cta-ghost text-sm whitespace-nowrap self-start lg:self-center"
        >
          Mehr über uns <ArrowUpRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  </section>
);
